import Profile from "../Model/Profile.ts";
import {ZapleczeApi} from "../ZapleczeApi.ts";
import LeadStatus from "../Model/LeadStatus.ts";

class LeadManagementApi extends ZapleczeApi {

    public constructor(token: string, profile: Profile ) {
        super(token, profile);
    }

    public async leadStatusTypes(): Promise<LeadStatus> {
        const url = this.getUrl() + '/api/v1/lead/statuses';
        try {
            return  await this.get<LeadStatus>(url);
        } catch (error) {
            console.error('Error fetching lead status types:', error);
            throw error;
        }
    }
}

export default LeadManagementApi;